var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2165",
  "data-name": "Group 2165",
  transform: "translate(-2012 803)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2162",
  "data-name": "Group 2162",
  transform: "translate(907 -1343)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_274",
  "data-name": "Rectangle 274",
  width: 16,
  height: 16,
  rx: 2,
  transform: "translate(1105 540)",
  fill: "#36c626"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M9.68.213l-6.6,6.623L1.356,3.822a.726.726,0,1,0-1.26.72L2.29,8.382a.727.727,0,0,0,.631.367.719.719,0,0,0,.359-.095.757.757,0,0,0,.171-.135l.008-.008,7.248-7.27a.726.726,0,0,0,0-1.026A.72.72,0,0,0,9.68.213Z",
  transform: "translate(1107.907 543.471)",
  fill: "#fff"
})))));
export default __webpack_public_path__ + "static/media/attcheck.7dc2f27f.svg";
export { SvgComponent as ReactComponent };